export default __webpack_public_path__ + "static/media/global-checkin-norefill.45b4f291.mp4";